import React, { Fragment, useContext, useEffect } from 'react';
import { Container } from '../../LayoutSlider.styles';
import { LayoutContext } from '../../../../../../contexts/layoutContext';
import Brand from '../../../../../pages/brand/Brand';
import { isEmpty } from '../../../../../../utils/helper';
import Supplier from '../../../../../pages/supplier';
import Ingredient from '../../../../../pages/ingredient';
import IngredientDetails from '../../../../../pages/ingredientDetails';
import { EditBilling } from '../../../../../pages/editBilling';

const TopLayoutSlider = () => {
  const { isOpen, topSliderToggle, topSliderPage, dispatch } = useContext(
    LayoutContext
  );

  useEffect(() => {
    if (!isEmpty(topSliderPage)) {
      dispatch({ type: 'TOGGLE_TOP_SLIDER' });
    }
  }, [topSliderPage, dispatch]);

  const getTopSliderPage = () => {
    switch (topSliderPage) {
      case 'brand':
        return <Brand />;
      case 'supplier':
        return <Supplier />;
      case 'ingredient':
        return <Ingredient />;
      case 'editIngredient':
        return <IngredientDetails />;
      case 'editBilling':
        return <EditBilling />;
      default:
        return <Fragment />;
    }
  };

  return (
    <Container showSlider={topSliderToggle} isOpen={isOpen} showAsPriority>
      {getTopSliderPage()}
    </Container>
  );
};

export default TopLayoutSlider;
